import angular from 'angular'
import template from './template.html'

angular.module('nominas.pendientes')
  .component('nominasPendientesTimbrar', {
    bindings: {
      idEmpresa: '<',
    },
    template: template,
    controller: Component,
  });

function Component($http, $filter) {
  let $ctrl = this,
    filterBy = $filter('filter');

  $ctrl.$onInit = $onInit;
  $ctrl.filtrar = filtrar;

  function $onInit() {
    $ctrl.filtro = '';

    $ctrl.$promise = $http.get('/api/nominas/pendientes/timbrar')
      .then(function ($resolve) {
        $ctrl.data = $filter('orderBy')($resolve.data, 'empresa');
        filtrar();
      });
  }

  function filtrar() {
    $ctrl.resultados = filterBy($ctrl.data, $ctrl.filtro);
  }
}



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/timbrar/component.js